import { createSelector } from 'reselect';
import DespatchParticularsReceptacleTypeColumns
  from '../../containers/DespatchParticularsReceptacleTypeColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_PARTICULARS_RECEPTACLE_TYPE.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_PARTICULARS_RECEPTACLE_TYPE.isLoading;

export const getData = ReportsDefinition.DESPATCH_PARTICULARS_RECEPTACLE_TYPE.getDataFunction();

export const getColumns = createSelector(getData, DespatchParticularsReceptacleTypeColumns);
